import axios from 'axios';

export default {
    namespaced: true,
    state: {
        busy: false,
        snackbarText: '',
        showSnackbar: false,
        snackbarTimeout: 3000
    },
    getters: {
        busy: state => state.busy,
        snackbarText: state => state.snackbarText,
        showSnackbar: state => state.showSnackbar,
        snackbarTimeout: state => state.snackbarTimeout
    },
    actions: {
        setSnackbarVisibility(context, isSnackbarVisible) {
            context.commit('setSnackbarVisibility', isSnackbarVisible);
        },
        async getPreDeliveryRequestDetailsByGuidAsync(context, trackedItemGuid) {
            return await axios.get('/PreDeliveryRequests/GetPreDeliveryRequestDetailsByGuidAsync', {
                params: {
                    trackedItemGuid: trackedItemGuid
                }
            })
                .then((response) => {
                    if (response.status === 200) {
                        response.data.error = false;

                        return response.data;
                    }

                    const errorMessage = `Failed to fetch pre-delivery request details for GUID: ${trackedItemGuid}.`;

                    context.commit('setSnackbarText', errorMessage);
                    context.commit('setSnackbarTimeout', 3000);
                    context.commit('setSnackbarVisibility', true);

                    return { 
                        error: true, 
                        errorMessage: errorMessage 
                    };
                }, (error) => {
                    console.error(error);

                    context.commit('setSnackbarText', 'An error has occurred.');
                    context.commit('setSnackbarTimeout', 10000);
                    context.commit('setSnackbarVisibility', true);

                    return { 
                        error: true, 
                        errorMessage: `An error occurred while retrieving pre-delivery request details: ${error}`
                    };
                });
        },
        async confirmPreDeliveryRequestSelectionAsync(context, { 
            trackedItemGuid, 
            defaultLockerCode, 
            recipientConfirmationAccepted, 
            closestPostOfficeCode,
            selectedSpecialLocationCode,
            chosenPredeliveryOption }) {
            return await axios.post('/PreDeliveryRequests/ConfirmPreDeliveryRequestSelectionAsync', 
                { 
                    "TrackedItemGuid": trackedItemGuid, 
                    "DefaultLockerCode": defaultLockerCode,
                    "RecipientConfirmationAccepted": recipientConfirmationAccepted,
                    "ClosestPostOfficeCode": closestPostOfficeCode,
                    "SelectedSpecialLocationCode": selectedSpecialLocationCode,
                    "ChosenPredeliveryOption": chosenPredeliveryOption
                })
                .then((response) => {
                    if (response.status === 200) {
                        response.data.error = false;

                        return response.data;
                    }

                    const errorMessage = `Failed to submit pre-delivery request confirmation for GUID: ${trackedItemGuid}.`;

                    context.commit('setSnackbarText', errorMessage);
                    context.commit('setSnackbarTimeout', 3000);
                    context.commit('setSnackbarVisibility', true);

                    return { 
                        error: true, 
                        errorMessage: errorMessage 
                    };
                }, (error) => {
                    console.error(error);

                    context.commit('setSnackbarText', 'An error has occurred.');
                    context.commit('setSnackbarTimeout', 10000);
                    context.commit('setSnackbarVisibility', true);

                    return { 
                        error: true, 
                        errorMessage: `An error occurred while submitting the pre-delivery request confirmation: ${error}`
                    };
                });
        }
    },
    mutations: {
        setBusy(state, payload) {
            state.busy = payload;
        },
        setSnackbarText(state, payload) {
            state.snackbarText = payload;
        },
        setSnackbarVisibility(state, payload) {
            state.showSnackbar = payload;
        },
        setSnackbarTimeout(state, payload) {
            state.snackbarTimeout = payload;
        }
    }
  }
  